import React, { FC } from 'react';
import * as S from '../../styled';
import { WEIGHT_VALUES } from '../../../../constants';

interface Props {
	weightUnit: string;
	currentWeightValue: string;
	onChangeWeightUnit: (e: any) => void;
	onChangeWeightValue: (e: any) => void;
}

export const CurrentWeightInputBlock: FC<Props> = props => {
	const { weightUnit, currentWeightValue, onChangeWeightUnit, onChangeWeightValue } = props;

	return (
		<>
			<S.Title>Your current weight?</S.Title>
			<S.ValueContainer>
				<S.Input
					id='currentWeightValue'
					type='number'
					name='currentWeightValue'
					value={currentWeightValue}
					placeholder='0'
					onChange={e => onChangeWeightValue(e)}
				/>
				<S.FormRadioGroup>
					<S.FormRadioGroupItem>
						<input
							id='currentWeightLbs'
							type='radio'
							name='currentWeight'
							value={WEIGHT_VALUES.LBS}
							checked={weightUnit === WEIGHT_VALUES.LBS}
							onChange={e => onChangeWeightUnit(e)}
						/>
						<label htmlFor='currentWeightLbs'>Lbs</label>
					</S.FormRadioGroupItem>
					<S.FormRadioGroupItem>
						<input
							id='currentWeightKg'
							type='radio'
							name='currentWeight'
							value={WEIGHT_VALUES.KG}
							checked={weightUnit === WEIGHT_VALUES.KG}
							onChange={e => onChangeWeightUnit(e)}
						/>
						<label htmlFor='currentWeightKg'>Kg</label>
					</S.FormRadioGroupItem>
				</S.FormRadioGroup>
			</S.ValueContainer>
		</>
	);
};
